import { FC, HTMLAttributes } from "react";
import { map } from "lodash-es";
import { Typography, TypographyVariant, Icon } from "@onmo/ui";
import { IMenu } from "../../../types/settings";
import { useStyles } from "./MenuCategory.style";

interface IMenuCategoryProps {
  title: string;
  menus: IMenu[];
}

export const MenuCategory: FC<
  IMenuCategoryProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const classes = useStyles();
  const { title, menus, ...otherProps } = props;

  return (
    <div {...otherProps}>
      <Typography variant={TypographyVariant.HeadingH6Bold}>{title}</Typography>
      <div className={classes.content}>
        {map(menus, (menu, idx) => (
          <div
            key={idx}
            className={classes.card}
            onClick={() => menu?.onAction?.()}
          >
            <div className={classes.leftContent}>
              {menu.icon}
              <Typography variant={TypographyVariant.BodyB4Regular}>
                {menu.title}
              </Typography>
            </div>
            <Icon name="icon-bold-arrow-right-3" className={classes.arrow} />
          </div>
        ))}
      </div>
    </div>
  );
};
